import { render, staticRenderFns } from "./CustomerPrototypeItemList.vue?vue&type=template&id=78ebcdc8&scoped=true"
import script from "./CustomerPrototypeItemList.vue?vue&type=script&lang=js"
export * from "./CustomerPrototypeItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ebcdc8",
  null
  
)

export default component.exports